import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, getLinkTo, title, groups } = appSections.stockBlocked;
export const stockBlockedRoute = {
    path: rootPath,
    lazy: async () => {
        const { BlockedItemsContainer } = await import('@/warehouse/modules/stockBlocked');
        return {
            element: (_jsx(ProtectedRoute, { groups: groups, children: _jsx(BlockedItemsContainer, {}) })),
        };
    },
    handle: {
        crumb: ({ params: { locationId } }) => _jsx(NavLink, { to: getLinkTo(locationId), children: title }),
    },
};
